/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUnitsAcquisitionParameters } from '../fn/acquisition/get-units-acquisition-parameters';
import { GetUnitsAcquisitionParameters$Params } from '../fn/acquisition/get-units-acquisition-parameters';
import { getUnitsDeviantTagsAcquisitionParameters } from '../fn/acquisition/get-units-deviant-tags-acquisition-parameters';
import { GetUnitsDeviantTagsAcquisitionParameters$Params } from '../fn/acquisition/get-units-deviant-tags-acquisition-parameters';
import { getUnitsTagsAcquisitionParameters } from '../fn/acquisition/get-units-tags-acquisition-parameters';
import { GetUnitsTagsAcquisitionParameters$Params } from '../fn/acquisition/get-units-tags-acquisition-parameters';
import { searchUnitsAcquisitionParameters$Any } from '../fn/acquisition/search-units-acquisition-parameters-any';
import { SearchUnitsAcquisitionParameters$Any$Params } from '../fn/acquisition/search-units-acquisition-parameters-any';
import { searchUnitsAcquisitionParameters$Json } from '../fn/acquisition/search-units-acquisition-parameters-json';
import { SearchUnitsAcquisitionParameters$Json$Params } from '../fn/acquisition/search-units-acquisition-parameters-json';
import { TagAcquisition } from '../models/tag-acquisition';
import { UnitAcquisitionState } from '../models/unit-acquisition-state';
import { UnitAcquisitionStatePagedList } from '../models/unit-acquisition-state-paged-list';
import { updateUnitsAcquisitionParameters } from '../fn/acquisition/update-units-acquisition-parameters';
import { UpdateUnitsAcquisitionParameters$Params } from '../fn/acquisition/update-units-acquisition-parameters';


/**
 * All about the acquisition parameters features
 */
@Injectable({ providedIn: 'root' })
export class AcquisitionService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUnitsAcquisitionParameters()` */
  static readonly GetUnitsAcquisitionParametersPath = '/units/acquisition-parameters';

  /**
   * Get all units acquisition parameters.
   *
   * Return all unique units and their acquisition parameters
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnitsAcquisitionParameters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitsAcquisitionParameters$Response(params?: GetUnitsAcquisitionParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UnitAcquisitionState>>> {
    return getUnitsAcquisitionParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all units acquisition parameters.
   *
   * Return all unique units and their acquisition parameters
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnitsAcquisitionParameters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitsAcquisitionParameters(params?: GetUnitsAcquisitionParameters$Params, context?: HttpContext): Observable<Array<UnitAcquisitionState>> {
    return this.getUnitsAcquisitionParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UnitAcquisitionState>>): Array<UnitAcquisitionState> => r.body)
    );
  }

  /** Path part for operation `updateUnitsAcquisitionParameters()` */
  static readonly UpdateUnitsAcquisitionParametersPath = '/units/acquisition-parameters';

  /**
   * Update all units acquisition parameters.
   *
   * Update all units acquisition parameters
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUnitsAcquisitionParameters()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUnitsAcquisitionParameters$Response(params: UpdateUnitsAcquisitionParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UnitAcquisitionState>>> {
    return updateUnitsAcquisitionParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Update all units acquisition parameters.
   *
   * Update all units acquisition parameters
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUnitsAcquisitionParameters$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUnitsAcquisitionParameters(params: UpdateUnitsAcquisitionParameters$Params, context?: HttpContext): Observable<Array<UnitAcquisitionState>> {
    return this.updateUnitsAcquisitionParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UnitAcquisitionState>>): Array<UnitAcquisitionState> => r.body)
    );
  }

  /** Path part for operation `searchUnitsAcquisitionParameters()` */
  static readonly SearchUnitsAcquisitionParametersPath = '/units/acquisition-parameters/search';

  /**
   * Get a pagination of units acquisition parameters.
   *
   * Get a pagination of units acquisition parameters
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUnitsAcquisitionParameters$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUnitsAcquisitionParameters$Json$Response(params?: SearchUnitsAcquisitionParameters$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitAcquisitionStatePagedList>> {
    return searchUnitsAcquisitionParameters$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a pagination of units acquisition parameters.
   *
   * Get a pagination of units acquisition parameters
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUnitsAcquisitionParameters$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUnitsAcquisitionParameters$Json(params?: SearchUnitsAcquisitionParameters$Json$Params, context?: HttpContext): Observable<UnitAcquisitionStatePagedList> {
    return this.searchUnitsAcquisitionParameters$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitAcquisitionStatePagedList>): UnitAcquisitionStatePagedList => r.body)
    );
  }

  /**
   * Get a pagination of units acquisition parameters.
   *
   * Get a pagination of units acquisition parameters
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUnitsAcquisitionParameters$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchUnitsAcquisitionParameters$Any$Response(params?: SearchUnitsAcquisitionParameters$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitAcquisitionStatePagedList>> {
    return searchUnitsAcquisitionParameters$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a pagination of units acquisition parameters.
   *
   * Get a pagination of units acquisition parameters
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUnitsAcquisitionParameters$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchUnitsAcquisitionParameters$Any(params?: SearchUnitsAcquisitionParameters$Any$Params, context?: HttpContext): Observable<UnitAcquisitionStatePagedList> {
    return this.searchUnitsAcquisitionParameters$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitAcquisitionStatePagedList>): UnitAcquisitionStatePagedList => r.body)
    );
  }

  /** Path part for operation `getUnitsDeviantTagsAcquisitionParameters()` */
  static readonly GetUnitsDeviantTagsAcquisitionParametersPath = '/units/{uid}/specials-acquisition-parameters';

  /**
   * Get all units deviant tags and their acquisition parameters.
   *
   * Return all tags with a deviant acquisition parameters and these parameters
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnitsDeviantTagsAcquisitionParameters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitsDeviantTagsAcquisitionParameters$Response(params: GetUnitsDeviantTagsAcquisitionParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagAcquisition>>> {
    return getUnitsDeviantTagsAcquisitionParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all units deviant tags and their acquisition parameters.
   *
   * Return all tags with a deviant acquisition parameters and these parameters
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnitsDeviantTagsAcquisitionParameters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitsDeviantTagsAcquisitionParameters(params: GetUnitsDeviantTagsAcquisitionParameters$Params, context?: HttpContext): Observable<Array<TagAcquisition>> {
    return this.getUnitsDeviantTagsAcquisitionParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TagAcquisition>>): Array<TagAcquisition> => r.body)
    );
  }

  /** Path part for operation `getUnitsTagsAcquisitionParameters()` */
  static readonly GetUnitsTagsAcquisitionParametersPath = '/units/{uid}/tags-acquisition-parameters';

  /**
   * Get all units tags and their acquisition parameters.
   *
   * Return all tags and their acquisition parameters
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnitsTagsAcquisitionParameters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitsTagsAcquisitionParameters$Response(params: GetUnitsTagsAcquisitionParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagAcquisition>>> {
    return getUnitsTagsAcquisitionParameters(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all units tags and their acquisition parameters.
   *
   * Return all tags and their acquisition parameters
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnitsTagsAcquisitionParameters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitsTagsAcquisitionParameters(params: GetUnitsTagsAcquisitionParameters$Params, context?: HttpContext): Observable<Array<TagAcquisition>> {
    return this.getUnitsTagsAcquisitionParameters$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TagAcquisition>>): Array<TagAcquisition> => r.body)
    );
  }

}
